import { Component, computed, input } from '@angular/core';
import { ConstructionSiteLinkPipe } from '@web/shared/pipes/construction-site-link.pipe';
import { ConstructionSiteCodeTagComponent } from '../../construction-site-code-tag.component';
import { SearchConstructionSiteEntry } from '../interfaces/search-construction-site-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';
import { SearchStatusChipComponent } from './search-status-chip.component';

@Component({
  selector: 'app-search-construction-site-item',
  imports: [
    ConstructionSiteCodeTagComponent,
    ConstructionSiteLinkPipe,
    SearchItemBaseComponent,
    SearchStatusChipComponent,
  ],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-hammer"
      color="text-soe-brick-clay"
      [detailRouterLink]="_item | constructionSiteLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-construction-site-code-tag [constructionSite]="_item" [clickable]="false" />
      </ng-template>

      <ng-template #statusChip>
        @if (_item.statusName) {
          <app-search-status-chip
            [name]="_item.statusName"
            [backgroundColor]="_item.statusColor"
            [textColor]="_item.statusTextColor"
          />
        }
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchConstructionSiteItemComponent {
  readonly item = input.required<SearchConstructionSiteEntry>();

  readonly detailItems = computed<DetailItem[]>(() => []);
}
